import React from 'react'
import { IApplicationFormData } from '../../models/application-form'
import { getFirstName, IsInviteApplication } from './coApplicantInviteContext'

interface Props {
  step: number
  totalSteps: number
  title: string
  showProgressBar: boolean
  data?: IApplicationFormData
  onBack?: () => void
}


type CoApplicantContextBannerProps = {
    data?: IApplicationFormData
}

const CoApplicantContextBanner = ({ data }: CoApplicantContextBannerProps) => {
    if (!IsInviteApplication(data)) {
        return null
    }

    const primaryApplicantName = data?.primaryApplicantName?.trim()
    const primaryFirstName = getFirstName(primaryApplicantName)
    const applicationType = data?.applicationType || 'Application'
    const initial = (primaryFirstName || primaryApplicantName || 'P').slice(0, 1).toUpperCase()

    return (
        <div className='wizard-context-banner' role='status'>
            <div className='wizard-context-banner-inner'>
                <div className='wizard-context-avatar' aria-hidden='true'>
                    {initial}
                </div>
                <div className='wizard-context-copy'>
                    <div className='wizard-context-title'>
                        {primaryFirstName
                            ? `Joining ${primaryFirstName}'s application`
                            : "Joining the primary renter's application"}
                    </div>
                    <div className='wizard-context-subtitle'>
                        {applicationType}
                    </div>
                </div>
            </div>
        </div>
    )
}

const WizardHeader: React.FC<Props> = ({step, totalSteps, title, showProgressBar, onBack, data}) => {
  const progress = totalSteps > 0 ? Math.max(0, Math.min(1, step / totalSteps)) : 0
  const segmentCount = 1
  const segmentProgress = progress * segmentCount

  return (
    <header className='wizard-header position-sticky top-0'>
      <div className='wizard-header-inner'>
        <div className='wizard-header-left'>
          <button
            className='btn wizard-header-back d-flex align-items-center justify-content-center'
            onClick={onBack}
            type='button'
            disabled={!onBack}
            aria-label='Back'
          >
            <i className='bi bi-arrow-left' style={{fontSize: '20px'}}></i>
          </button>
        </div>

        <div className='wizard-header-center'>
          <img src='/media/logos/doora-logo.png' alt='Doora Logo' className='wizard-header-logo' />
        </div>

        <div className='wizard-header-right'>
          <span className='wizard-header-title wizard-header-title-desktop text-truncate d-inline-block'>
            {title}
          </span>
        </div>
      </div>

      {showProgressBar && (
        <div className='wizard-progress-wrap'>
          <div
            className='wizard-progress-segments_'
            role='progressbar'
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={Math.round(progress * 100)}
          >
            {Array.from({length: segmentCount}).map((_, index) => {
              const fill = Math.max(0, Math.min(1, segmentProgress - index))
              return (
                <div key={index} className='wizard-progress-segment'>
                  <div className='wizard-progress-segment-fill' style={{width: `${fill * 100}%`}} />
                </div>
              )
            })}
          </div>
        </div>
      )}

      <CoApplicantContextBanner data={data} />
    </header>
  )
}

export default WizardHeader
